import React, { Component } from 'react';
import Chart from 'react-apexcharts';

class GridGraphSetup extends Component {
  state = {
    series: [
      {
        name: 'To Grid',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
      },
      {
        name: 'From Grid',
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
      }
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        }
      },

      title: {
        text: 'Grid Consumption',
        align: 'left'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: [
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct'
        ]
      },

      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + ' kWh';
          }
        }
      }
    }
  };

  render() {
    return (
      <div id="chart">
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={350}
        />
      </div>
    );
  }
}

export default GridGraphSetup;
